import {Link} from "../atoms/link";
import {BreadCrumb} from "../../types/hygiena-types";
import classNames from "classnames";

/**
 * Element for displaying breadcrumbs.
 *
 * @param breadcrumbs
 *   An array of breadcrumbs.
 * @constructor
 */
export function BreadCrumbs({breadcrumbs}: {breadcrumbs : BreadCrumb[]}): JSX.Element {
  return (
    <div className="text-primary font-semibold mb-4 text-sm md:text-base">
      {breadcrumbs.map((item, index) => {
        if (item.url) {
          return (
            <div className={classNames("inline")} key={item.id}>
              <Link href={item.url ?? "/"} className={classNames(
                "hover:text-white transition-all",
                {"max-md:hidden": index === 0}
              )}>{item.name}</Link>
              {index + 1 < breadcrumbs.length && (<span className={classNames("px-1.5", {"max-md:hidden": index === 0})}>/</span>)}
            </div>
          )
        }
      })}
    </div>
  )
}